import { guidesByPlatform } from '@hotjar/webapp/constants/integration-guides';
import type { CMS, Platform } from '../types';

const DEFAULT_PLATFORMS = [
  'gtm',
  'wordpress',
  'shopify',
  'wix',
  'magento',
  'squarespace',
  'drupal',
  'prestashop',
  'clickfunnels',
  'woocommerce',
];

export const useIntegrationPlatforms = (exclude?: CMS | 'gtm'): Platform[] => {
  return DEFAULT_PLATFORMS.reduce((guides: Platform[], platform: string) => {
    if (platform !== exclude) {
      const guide = guidesByPlatform[platform];
      guides.push({ id: platform as CMS, ...guide });
    }
    return guides;
  }, [] as Platform[]).slice(0, 9);
};
